import { isEqual } from 'lodash';
import { filter, OperatorFunction, scan, timestamp } from 'rxjs';
import { map } from 'rxjs/operators';

const initialValue = Symbol();

interface IScanPayload<T> {
  emittedValue: T | typeof initialValue;
  isAllowedToBeForwarded: boolean;
  lastEmitTime: number;
}

export function onlyAllowDistinctForDuration<T>(
  durationMs = 100,
  compareFn: (a: T, b: T) => boolean = isEqual,
): OperatorFunction<T, T> {
  return (source$) =>
    source$.pipe(
      timestamp(),
      scan(
        (state: IScanPayload<T>, { value: emittedValue, timestamp: emitTime }): IScanPayload<T> => {
          const { emittedValue: lastEmittedValue, lastEmitTime } = state;
          const isAllowedToBeForwarded =
            lastEmittedValue === initialValue ||
            !compareFn(emittedValue, lastEmittedValue) ||
            emitTime - lastEmitTime >= durationMs;

          return isAllowedToBeForwarded
            ? {
                emittedValue,
                isAllowedToBeForwarded: true,
                lastEmitTime: emitTime,
              }
            : {
                ...state,
                isAllowedToBeForwarded: false,
              };
        },
        {
          emittedValue: initialValue,
          isAllowedToBeForwarded: false,
          lastEmitTime: 0,
        },
      ),
      filter((state) => state.isAllowedToBeForwarded),
      map((state) => state.emittedValue as T),
    );
}
